import {FC} from 'react'
import {useIntl} from 'react-intl'
import SharedData from '../modules/common/SharedData'
import {minutesSinceStockUpdate, shopLabel, shopOf, stockUpdateOverdue} from '../modules/common/stockScope'

/**
 * "You are updating the shelf at {store}" — shown on every stock screen when the signed-in supplier
 * runs a partner shop, so nobody mistakes a shelf count for national supplier stock. Turns into a
 * warning once the store is past its hourly "update your stock" period. Renders nothing for an
 * ordinary supplier.
 */
const ShopScopeBanner: FC = () => {
  const {formatMessage} = useIntl()
  const {currentUser} = SharedData()
  const shop = shopOf(currentUser)
  if (!shop) {
    return null
  }

  const overdue = stockUpdateOverdue(shop)
  const minutes = minutesSinceStockUpdate(shop)
  const lastUpdate =
    minutes === null
      ? formatMessage({id: 'shop_scope.never_updated'})
      : formatMessage({id: 'shop_scope.updated_minutes_ago'}, {minutes})

  return (
    <div
      className={`alert ${overdue ? 'alert-warning' : 'alert-primary'} d-flex align-items-center gap-3 mb-5`}
      role={overdue ? 'alert' : 'status'}
    >
      <span className="material-symbols-outlined" aria-hidden="true">
        {overdue ? 'warning' : 'storefront'}
      </span>
      <div>
        <div className="fw-bold">
          {formatMessage({id: 'shop_scope.title'}, {store: shopLabel(shop)})}
        </div>
        <div>
          {formatMessage({id: 'shop_scope.body'})} {lastUpdate}
          {overdue ? ` ${formatMessage({id: 'shop_scope.overdue'})}` : ''}
        </div>
      </div>
    </div>
  )
}

export default ShopScopeBanner
